import AccountState from './Types';

import { AccountActionTypes, AccountActions } from './actions';

const initialState: AccountState = {
    phoneNumbers: [],
};

export default function accountReducer(state: AccountState = initialState, action: AccountActionTypes): AccountState {
    switch (action.type) {
        case AccountActions.SET_PHONE_NUMBERS:
            return {
                ...state,
                phoneNumbers: [...action.payload],
            };
        default:
            return {
                ...state,
            };
    }
}
